import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Box, Spacer, Heading, Text, Paragraph } from '@zillow/constellation';
import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { isEditor } from '../../utils/isEditor.js';
import { omitUndefined } from '../../utils/lodash.js';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import { FieldConfig, useLastValidDownPaymentValues } from './DownPaymentCalculator.utils.js';
import DownPaymentFields from './DownPaymentFields.js';

var DownPaymentCalculator = function DownPaymentCalculator(_ref) {
  var _defaultValues$FieldC, _Object$assign;
  var defaultValues = _ref.defaultValues;
  // Otherwise, on server side the default value is different, and we have
  // hydration error, and the wrong percentage hint button is
  // selected/highlighted.
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  useEffect(function () {
    setLoaded(true);
  }, []);
  if (!loaded) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    as: CalculatorForm,
    fieldStorageKey: "DownPaymentCalculatorFields",
    calcTypeForMarketing: "DownPayment",
    editorMode: isEditor(),
    defaultValues: Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.homePrice.name] = 650000, _Object$assign[FieldConfig.other.name] = (_defaultValues$FieldC = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[FieldConfig.percentage.name]) !== null && _defaultValues$FieldC !== void 0 ? _defaultValues$FieldC : 12, _Object$assign[FieldConfig.percentage.name] = 10, _Object$assign), omitUndefined(defaultValues)),
    sx: {
      paddingBottom: '$spacing.sm',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      '@media $lg': {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingBottom: 0
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      flex: '1 1 40%',
      padding: '10px',
      paddingBottom: '0px',
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/React.createElement(DownPaymentFields, null)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      flex: '1 1 60%',
      padding: '$spacing.xs',
      paddingBottom: '0px',
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/React.createElement(Spacer, {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "4",
    marginBottom: "xs",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, "Your down payment amount is:", /*#__PURE__*/React.createElement(Text, {
    style: {
      display: 'block'
    },
    fontType: "h2",
    fontColor: "green500",
    margin: "md"
  }, /*#__PURE__*/React.createElement(DownPaymentAmountValue, null))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Paragraph, {
    style: {
      margin: '25px'
    }
  }, "Based on the home price and down payment percentage, this is the estimated dollar amount you'll need to bring as your down payment, due at closing.")))));
};
var DownPaymentAmountValue = function DownPaymentAmountValue() {
  var form = useFormContext();
  var values = useLastValidDownPaymentValues(form);
  var downPaymentValue = values.fields.homePrice <= 0 ? 0 : values.fields.homePrice * values.fields.percentage / 100;
  return '$' + commaSeparateNumber(downPaymentValue);
};
var DownPaymentCalculator$1 = DownPaymentCalculator;

export { DownPaymentCalculator$1 as default };
